import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'developer-portal-page-hero',
  templateUrl: './page-hero.component.html',
  styleUrls: ['./page-hero.component.scss'],
})
export class PageHeroComponent implements OnInit {
  @Input() title: string;
  @Input() description?: string;

  constructor() {}

  ngOnInit(): void {}
}
